const Start = [
  {
    heroTitle: "Wallet Section",
    subTitle: "How to use the wallet section in coinnik Market?",
    body: [
      "Log in to the user panel.",
      "Select the fourth option, the wallet, from the menu on the right side of the page.",
      "You will be taken to a page listing your wallets.",
      "Charge one of your wallets to start buying and selling.",
      "To buy and sell with Toman, first charge your Toman wallet through the bank portal.",
    ],
    content:
      "Can you increase your trading volume to buy and sell in the market with less and more economical commission?",
    firstContent: "Considered_monthly",
    video: "https://www.aparat.com/video/video/embed/videohash/VRJBt/vt/frame",
  },
  {
    heroTitle: "Charging wallet",
    subTitle: "How to top up your wallet atcoinnik Market?",
    content:
      "You can also use QuinnMarket platform wallets to store your Toman assets and digital currency, and you no longer need a wallet.",
    body: [
      "From the wallet section, enter your wallet list and select the Deposit Wallet Deposit option. Select a card on the deposit page and specify the deposit amount.",
      "If you have not defined a bank card before, enter the settings section from the main menu and then enter the bank accounts section.",
      "Enter your card and account information. Now you can top up your Toman wallet through the bank portal.",
      "To withdraw Tomans, enter the Tomans wallet of the withdrawal section from the wallet section.",
      "To deposit a blockchain, enter the wallet deposit section. An address will be displayed to you. Copy it and make your deposit through the source wallet.",
      "To withdraw the blockchain, enter the wallet withdrawal section. Enter the destination wallet address and withdrawal amount. After entering the confirmation code, your transfer will be done.",
    ],
    firstContent: "Note_withdrawal",
    video: "https://www.aparat.com/video/video/embed/videohash/4gzKP/vt/frame",
  },
  {
    heroTitle: "Crypto currency transfer",
    subTitle: "How to transfer digital currency through coinnik market?",
    content:
      "You can transfer digital currency to domestic or foreign wallets through Kevin Nick Market wallets",
    body: [
      "To deposit a blockchain, enter the desired wallet deposit section. An address will be displayed to you.",
      "Copy it and make your deposit through the source wallet",
      "To withdraw the blockchain, enter the wallet withdrawal section",
      "Enter the destination wallet address and withdrawal amount",
      "After entering the confirmation code, your transfer will be done",
      "After entering the transfer amount, you can see the fee and the final number that is transferred",
    ],
    firstContent: "Notification_messag",
    video: "https://www.aparat.com/video/video/embed/videohash/fCpug/vt/frame",
  },
];
export default Start;
